import React from 'react';
import CalendarIcon from '@atlaskit/icon/glyph/calendar';
import PremiumIcon from '@atlaskit/icon/glyph/premium';
import { Stack, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { type TimelineEvent, Timeline } from '../../../common/ui/timeline';
import messages from './messages';

type Props = {
	trialEndTime?: number;
};

export function TimelineSection({ trialEndTime }: Props) {
	const { formatMessage } = useIntl();

	let formattedTrialStartMessage;
	let formattedTrialEndMessage;

	if (trialEndTime) {
		const trialDate = new Date(trialEndTime);
		const formattedEndDate = trialDate.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		});

		formattedTrialEndMessage = formatMessage(messages.standardTrialEnds, {
			trialEndDate: formattedEndDate,
		});

		trialDate.setDate(trialDate.getDate() - 14);

		const formmattedStartDate = trialDate.toLocaleDateString('en-US', {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		});

		formattedTrialStartMessage = formatMessage(messages.standardTrialBegins, {
			trialStartDate: formmattedStartDate,
		});
	} else {
		formattedTrialStartMessage = formatMessage(messages.standardTrialBeginsWithoutDate);
		formattedTrialEndMessage = formatMessage(messages.standardTrialEndsWithoutDate);
	}

	const timelineEvents: TimelineEvent[] = [
		{
			icon: <PremiumIcon label="Premium Icon" size="small" />,
			title: formattedTrialStartMessage,
			description: formatMessage(messages.standardTrialBeginsDescription),
			iconBackgroundStyles: xcss({
				color: 'color.text.selected',
				borderColor: 'color.border.selected',
			}),
		},
		{
			icon: <CalendarIcon label="Calendar Icon" size="small" />,
			title: formattedTrialEndMessage,
			description: formatMessage(messages.standardTrialEndsDescription),
			iconBackgroundStyles: xcss({
				color: 'color.text.subtlest',
				borderColor: 'color.border',
			}),
		},
	];

	return (
		<Stack
			xcss={TimelineSectionStyles}
			testId="upgrade-onboarding-experiment.ui.upgrade-onboarding-modal.timeline-section.benefits-section"
		>
			<Timeline timelineEvents={timelineEvents} />
		</Stack>
	);
}

const TimelineSectionStyles = xcss({
	paddingTop: 'space.300',
});
